import axios from 'axios'

export default {
    get: () => axios.get('executives'),
    store: (data) => axios.post('executives/store', data),
    update: (data) => axios.post('executives/update', data),
    downgrade: (data) => axios.post('executives/downgrade', data),
    delete: (id) => axios.post('executives/delete', id),
    import: (data) => axios.post('executives/import', data),
    generateLink: (data) => axios.post('executives/generate-link', data),

    // Puntos gerentes
    getPoints: () => axios.get('executives/points'),
    getRedeemablePoints: () => axios.get('executives/redeemable-points'),
    getRedeemablePointsHistory: (id) => axios.get('executives/redeemable-points-history/'+id),
    getExcelRedeemablePoints: () => axios.get('executives/redeemable-points-excel'),
    deleteRedeemablePoint: (id) => axios.post('executives/delete-redeemable-points', id),
    updatePoints: (data) => axios.post('executives/update-points', data),
    getPointTickets: (type) => axios.post('executives/point-tickets', {type: type}),
    getPointProducts: (type) => axios.post('executives/point-products', {type: type}),
    boughtAward: (data) => axios.post('executives/awards/bought', data),
    getAwardExchangesHistory: () => axios.get('executives/awards/exchanges-history'),
}